import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';

const DEFAULT_ALPHA = 1;
// 图片填充时的图片属性
export function setImageValue(value: object, model: IShapeModel | IPictureModel) {
    const { image } = model.props.style;
    value[ActionType.REGULATE] = {
        contrast: image?.contrast,
        brightness: image?.brightness,
        sharpenSoften: image?.sharpenSoften,
    };
    value[ActionType.PICTURE_COLOR] = {
        saturate: image?.saturate,
        colorTemperature: image?.colorTemperature,
    };
    const fillInfo = model.getBackgroundFill().getFillInfo();
    const alpha = model.type ===  UIModelType.SHAPE
        ? fillInfo?.image?.alpha ?? DEFAULT_ALPHA
        : (model as IPictureModel).props.style.alpha;
    value[ActionType.INSERT_PICTURE] = { alpha };
}
